import { ErrorCode } from './error-code';

export class OperationResult<T> {

    constructor(public Code: ErrorCode,
                public Result: T) { }

}
